export default __webpack_public_path__ + "static/media/lamb_grayscale.0788b6e7.svg";